import { useEffect, useState } from 'react';
import api from '../../api/axios';

import styles from '../dash_styles/vieworder.module.css';
import CurrencyDisplay from "../dash_component/CurrencyDisplay";
import getDate from './getDate';

import { FaRegClock } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { MdClose } from "react-icons/md";



const ViewOrder = ({ order, orderItems, setSelectedOrder }) => {
    const [products, setProducts] = useState([]);
    const [users, setUsers] = useState([]);

    const fetchProductData = async () => {
        try {
            const res = await api.get('/products')
            setProducts(res.data)
        } catch (error) {
            console.error('Error fetching product data', error);
        }
    };

    const fetchUser = async () => {
        try {
            const res = await api.get('/user');
            setUsers(res.data.users);
        } catch (error) {
            console.error('Error fetching users', error);
        }
    };

    useEffect(() => {
        fetchProductData();
        fetchUser();
    }, []);

    const customer = users.find(u => u.id === order.customer_id);
    

    const productMap = {};
    products.forEach(p => {
        productMap[p.id] = p.title;
    })

    return (
        <div className={styles.mainContainers}>
            <div className={styles.orderDetails}>
                <div className={styles.header}>
                    <p style={{ 
                        textTransform: 'uppercase',
                        fontSize: '25px',
                        fontWeight: 400,

                    }}>
                        po# FED-02340{order.id}
                    </p>
                    <MdClose style={{ fontSize: '20px', cursor: 'pointer'}} onClick={() => setSelectedOrder(null)}/>
                </div>
                <div className={styles.poDetails} style={{ height: '400px'}}>
                    <div style={{ height: '50px', }}>
                        <div className={styles.label}>
                            <p>purchase order details</p>
                        </div>
                    </div>
                    <div className={styles.details}>
                        <div style={{ width: '33%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                            <div className={styles.inputContainer} style={{ width: '100%' }}>
                                <p>shipping</p>
                                <div className={styles.inputBox} style={{ background: 'none', border: 'none', width: '120px'}}><p>{order.shipping_address}</p></div>
                            </div>
                            <div className={styles.inputContainer} style={{ width: '100%', height: '120px'}}>
                                <p>billing</p>
                                <div className={styles.inputBox} style={{ background: 'none', border: 'none', width: '120px'}}><p>{order.billing_address}</p></div>
                            </div>
                            
                        </div>
                        <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                            <div className={styles.inputContainer}>
                                <p>name</p>
                                <div className={styles.inputBox}><p>{customer?.first_name} {customer?.last_name}</p></div>
                            </div>
                            <div className={styles.inputContainer}>
                                <p>email</p>
                                <div className={styles.inputBox}><p>{customer?.email}</p></div>
                            </div>
                            <div className={styles.inputContainer}>
                                <p>phone</p>
                                <div className={styles.inputBox}><p>{customer?.phone}</p></div>
                            </div>
                            <div className={styles.inputContainer}>
                                <p>payment method</p>
                                <div className={styles.inputBox}><p>{order.payment_method}</p></div>
                            </div>
                            <div className={styles.inputContainer}>
                                <p>date</p>
                                <div className={styles.inputBox}><p>{getDate(order.created_at)}</p></div>
                            </div>
                            <div className={styles.inputContainer}>
                                <p>total</p>
                                <div className={styles.inputBox}><p><CurrencyDisplay amount={order?.total} currency='CAD'/></p></div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className={styles.poDetails}>
                    <div style={{ height: '50px', }}>
                        <div className={styles.label}>
                            <p>purchase order items</p>
                        </div>
                    </div>
                    <div className={styles.details} style={{ padding: '27px'}}>
                        <div className={styles.mainTableContainer}>
                            <div className={styles.outerTable}>
                                <form >
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className={styles.col1}>Product name</th>
                                                <th className={styles.col2}>quantity</th>
                                                <th className={styles.col3}>material</th>
                                                <th className={styles.col4}>cost</th>
                                                <th className={styles.col5}>price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(orderItems) && orderItems.map(o => (
                                                <tr key={o.id} >
                                                    <td><p>{productMap[o.product_id]}</p></td>
                                                    <td><p>{o.quantity}</p></td>
                                                    <td><p>{o.material}</p></td>
                                                    <td><CurrencyDisplay amount={o.cost} currency='CAD'/></td>
                                                    <td><CurrencyDisplay amount={o.price} currency='CAD'/></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.statusConfirm}>
                <div className={styles.statusContainer}>
                    <div style={{ 
                            height: '40px', 
                            display: 'flex', 
                            columnGap: '15px', 
                            alignItems: 'center' 
                        }}>
                            <FaRegClock/>
                            <p style={{ fontWeight: 400 }}>Order Status</p>
                    </div>
                    <div className={styles.innerContent}>
                        <div style={{ display: 'flex', columnGap: '10px'}}>
                            <IoIosCheckmarkCircleOutline/>
                            <p style={{ fontWeight: 400}}>Order Funds Revieved</p>
                        </div>
                        <div style={{ display: 'flex', columnGap: '10px'}}>
                            <IoIosCheckmarkCircleOutline/>
                            <p style={{ fontWeight: 400}}>Order Manufactured</p>
                        </div>
                        <div style={{ display: 'flex', columnGap: '10px'}}>
                            <IoIosCheckmarkCircleOutline/>
                            <p style={{ fontWeight: 400}}>Order Shipping</p>
                        </div>
                        <div style={{ display: 'flex', columnGap: '10px'}}>
                            <IoIosCheckmarkCircleOutline/>
                            <p style={{ fontWeight: 400}}>Order Completed</p>
                        </div>
                        <button>Confirm</button>
                    </div>
                    <div className={styles.innerContent}>
                        <div style={{ height: '20px'}}>
                            <p>{order.status}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewOrder;